import { useEffect, useState } from "react";
import { useRoute, Link } from "wouter";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

// Very small markdown-ish renderer: headings (#, ##) and paragraphs. Enough for
// the seeded legal documents; avoids pulling in a markdown dependency.
function renderBody(body: string) {
  return body.split(/\n{2,}/).map((block, i) => {
    const t = block.trim();
    if (t.startsWith("## ")) return <h2 key={i} className="text-lg font-bold text-navy mt-5 mb-1">{t.slice(3)}</h2>;
    if (t.startsWith("# ")) return <h1 key={i} className="text-2xl font-extrabold text-navy mb-2">{t.slice(2)}</h1>;
    return <p key={i} className="text-sm text-navy/80 leading-relaxed mb-2 whitespace-pre-line">{t}</p>;
  });
}

export default function LegalDoc() {
  const [, params] = useRoute("/legal/:kind");
  const kind = (params?.kind === "privacy" ? "privacy" : "terms") as "terms" | "privacy";
  const [doc, setDoc] = useState<any | null>(null);
  const [state, setState] = useState<"loading" | "ready" | "error">("loading");

  useEffect(() => {
    setState("loading");
    api.legalDoc(kind).then((d) => { setDoc(d); setState(d ? "ready" : "error"); }).catch(() => setState("error"));
  }, [kind]);

  return (
    <div className="container-x py-8 max-w-3xl">
      <div className="text-sm text-mut mb-4">
        <Link href="/legal/terms" className={`hover:text-navy ${kind === "terms" ? "text-navy font-semibold" : ""}`}>Terms of Service</Link>
        {" · "}
        <Link href="/legal/privacy" className={`hover:text-navy ${kind === "privacy" ? "text-navy font-semibold" : ""}`}>Privacy Policy</Link>
      </div>
      {state === "loading" && <div className="flex items-center gap-2 text-mut"><Loader2 className="w-4 h-4 animate-spin" />Loading…</div>}
      {state === "error" && <p className="text-mut">This document isn't available yet.</p>}
      {state === "ready" && doc && (
        <article className="card p-6">
          <div className="text-xs text-mut mb-3">Version {doc.version}{doc.publishedAt ? ` · effective ${new Date(doc.publishedAt).toLocaleDateString()}` : ""}</div>
          {renderBody(doc.body)}
        </article>
      )}
    </div>
  );
}
